import React from 'react';
import { Box, Button, Container, Flex, Heading, Text } from '@chakra-ui/react';

import LandingPageBanner from '../assets/images/landing-page-background.png';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useRouter } from 'next/router';

const Story: React.FC<any> = () => {
	const router = useRouter();

	return (
		<Container maxW="7xl">
			<Flex position="relative">
				<Flex
					w={'100%'}
					backgroundImage={LandingPageBanner.src}
					backgroundSize={'45%'}
					backgroundRepeat={'no-repeat'}
					backgroundPosition={'590px 0;'}
					display={{ base: 'block', md: 'flex' }}
				>
					<Box marginTop="60px" mr="10" width={{ base: '100%', md: '240px' }}>
						<Flex display={{ base: 'block', md: 'flex' }} marginBottom={5} pb={3} borderBottom="1px">
							<Box mr={3} mb={{ base: 3, md: 0 }}>
								<Button
									onClick={() => {
										router.back();
									}}
									w={8}
									h={8}
									borderRadius={5}
									bg={'gray.800'}
								>
									<MdKeyboardArrowLeft />
								</Button>
							</Box>
							<Box>
								<Heading fontSize="28" width="240px">
									Story
								</Heading>
							</Box>
						</Flex>
					</Box>
					<Box className="itemBg" rounded="md" width={{ base: '100%', md: '70%' }} mt="8" p="8">
						<Text>
							The Ark was created as a Wildlife awareness platform, to allow content creators and non-profit organizations the
							opportunity to raise funds in the fight against poaching and conservation. Ark provides artists, photographers
							and other digital media influencers the ability to mint and sell NFT’s by connecting with a global audience on
							the Ark marketplace
						</Text>
					</Box>
				</Flex>
			</Flex>
		</Container>
	);
};

export default Story;
